import React from "react";
import { useNavigate } from "react-router-dom";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import IncentiveManagement from "./views/IncentiveManagement";

export default function IncentiveTableWrapper() {
     const navigate = useNavigate();

     return (
          <>
               <MainLeftTitle title="Incentive Campaign Management">
                    {/* <CreateButton
                         name="Create Incentive Campaign"
                          onClick={() => navigate("/app/incentive-data-manage/add")}
                    /> */}
               </MainLeftTitle>
               
               <IncentiveManagement/>
          </>
     );
}
